import { ISelectFilterOption } from '../../../shop-ui/components/search-page/interfaces';
import i18next from 'i18next';
import { IProductFilterOption } from 'PyzShopUi/scripts/product-detail-page/interfaces';

export interface IColorOption extends ISelectFilterOption{
    mappedColorName?: string;
}

const colorMap = new Map<string, string>();
colorMap.set('Beige', '#f5f5dc');
colorMap.set('Black', '#222222');
colorMap.set('Blue', '#2222dd');
colorMap.set('Brown', '#995500');
colorMap.set('Chrome', '#f8f8ff');
colorMap.set('Green', '#00aa00');
colorMap.set('Grey', '#aaaaaa');
colorMap.set('Orange', '#ffa500');
colorMap.set('Pink', '#ffcccc');
colorMap.set('Purple', '#aa00aa');
colorMap.set('Red', '#dd0000');
colorMap.set('White', '#eeeeee');
colorMap.set('Yellow', '#ffee00');

export const generateColorFilterOptions = (filterOptions: IProductFilterOption[]): Map<string, IColorOption> => {
    const filters: Map<string, IColorOption> = new Map<string, IColorOption>();

    filterOptions.forEach(filterOption => {
        const filterOptionsLength = filterOption.colors.length;

        if (filterOptionsLength >= 2) {
            const multiColorFilter = generateMultiColorFilter(filterOption, filterOptionsLength);
            filters.set(multiColorFilter.value, multiColorFilter);
        } else {
            const singleColorFilter = generateSingleColorFilter(filterOption)
            filters.set(singleColorFilter.value, singleColorFilter);
        }
    });

    return filters;
}

const generateSingleColorFilter = (filterOption: IProductFilterOption): IColorOption => ({
    value: filterOption.value,
    labelCssClass: filterOption.colors?.[0],
    mappedColorName: i18next.t(filterOption.colors?.[0], { ns: 'article-list-filter' }),
    label: '',
    selected: filterOption.selected,
    disabled: filterOption.disabled,
})

const generateMultiColorFilter = (filterOptions, size): IColorOption => {
    const colors = filterOptions.colors.map(color => colorMap.get(color));
    const [firstColor, secondColor, thirdColor, fourthColor] = colors;

    const filterOption: IColorOption = {
        value: filterOptions.value,
        mappedColorName: filterOptions.colors.map(color => i18next.t(color, { ns: 'article-list-filter' })).join(' '),
        label: '',
        selected: filterOptions.selected,
        disabled: filterOptions.disabled,
        multicolor: true,
        style: {
            borderColor: 'white',
        },
    }

    if (!firstColor || !secondColor && size >= 2 || !thirdColor && size >= 3 || !fourthColor && size >= 4) {
        return filterOption;
    }

    filterOption.style = {
        borderBottomColor: `${size === 2 ? secondColor : thirdColor}`,
        borderRightColor: `${size === 2 ? secondColor : size === 3 ? thirdColor : fourthColor}`,
        borderLeftColor: `${firstColor}`,
        borderTopColor: `${size === 2 ? firstColor : secondColor}`,
    };

    return filterOption;
}
